const operations = {
  add: (number, percent) => number + number * (percent * 0.01),
  subtract: (number, percent) => number - number * (percent * 0.01),
}

export default (type, number, percent) => operations[type](number, percent)
